import React from "react";

import { useTranslation } from "@common/hooks/translation";
import { useDispatch } from "react-redux";
import { CashoutMoney, EndVerificationSession } from "@app/dev/actions/terminal";
import { useBalance } from "@app/dev/terminal/hooks/balance";

export const VerificationLogout = () => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const terminalBalance = useBalance();

  const logout = () => {
    dispatch(EndVerificationSession());
    if (terminalBalance) dispatch(CashoutMoney(null));
  };

  return (
    <div className="log-out" onClick={logout}>
      <i className="global-icon icon-logout" />
      <p>{t("Log out")}</p>
    </div>
  );
};
